export default "__VITE_ASSET__CG3RXw4F__"